export type ImposterOnlineTranslate = (key: string, options?: Record<string, unknown>) => string;

/** Stable on-screen label when ``display_name`` is missing (never raw ids in UI). */
export function imposterOnlinePlayerLabel(
  row: { display_name?: string } | undefined,
  pid: string,
  t: ImposterOnlineTranslate,
): string {
  const n = (row?.display_name ?? "").trim();
  if (n) return n;
  const short = pid.replace(/^nm_/, "").slice(0, 4).toUpperCase() || pid.slice(-4).toUpperCase();
  return t("party.playImposterOnline.playerLabelFallback", { short });
}
